import parseResponseSTM from 'core/services/getPlansByProductId/parseResponseSTM'
import validateProfile from 'core/controllerPlans/validateProfile'
import { getPlansEnroll } from 'core/controllerPlans/getPlans'
import redirectCensus from 'core/DOM/redirectCensus'
import updateStorages from './updateStorages'
import initPage from 'core/initPage'
import updateMultiCarrierEligibility from 'sites/enroll.pivothealth.com/census/updateMultiCarrierEligibility'

export function initController(config) {
  return initPage({
    placement: config.placement,
    chatInteractionId: config.chatInteractionId,
    tags: [config.tagMaropost],
    clearStorage: config.clearStorage || false
  })
    .then(updateStorages)
    .then(updateMultiCarrierEligibility)
    .then(validateProfile)
    .then(getPlansEnroll)
    .then(parseResponseSTM)
    .catch(redirectCensus)
}

export default initController
